<app-ui-select-group
  [label]="label"
  [control]="control"
  [optionGroups]="options$ | async"
  [isMultiple]="isMultiple"
  [required]="required"
  [description]="description"
></app-ui-select-group>
